import { Layout, Typography } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Logo from 'src/assets/images/OMSLogoBlk.png'
import { login } from 'src/features/AuthSlice'
import {
  AuthBackdrop,
  AuthHeading,
  AuthLogo,
  AuthPageLayout,
  AuthSubheading,
  AuthSurface,
  AuthTrustText,
} from 'src/screens/login/authStyles'
import LoginForm from 'src/screens/login/LoginForm'

const Login = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth)
  const { error } = user

  const showError = error =>
    error === 'User does not exist.'
      ? 'The email address you entered is incorrect'
      : error === 'Incorrect username or password.'
      ? 'The password you entered is incorrect'
      : error

  return (
    <AuthPageLayout className='layout'>
      <AuthBackdrop />
      <Layout.Content>
        <AuthSurface>
          <AuthLogo src={Logo} alt='Orders Made Simple logo' />
          <AuthHeading level={2}>Welcome back</AuthHeading>
          <AuthSubheading>
            Sign in to access your purchasing dashboard securely.
          </AuthSubheading>
          <LoginForm
            user={user}
            submit={values => {
              dispatch(login(values))
            }}
          />
          {error && (
            <Typography.Text type='danger'>{showError(error)}</Typography.Text>
          )}
          <AuthTrustText>
            Secure login protected by enterprise-grade authentication
          </AuthTrustText>
        </AuthSurface>
      </Layout.Content>
    </AuthPageLayout>
  )
}

export default Login
